import {RxChatBubble} from "react-icons/rx";
import {withTranslation} from "react-i18next";
import {analyticsEvent} from "./AnalyticsManager";
import "./CYourOpinion.css";
import {GG_CATEGORY} from "../services/constant";

const CYourOpinion = (props) => {
    const {t} = props
    const opinionLink = t('home.opinionLink');
    const opinionTitle = t('home.opinionTitle');
    if (opinionLink === undefined || opinionTitle === null) {
        return null;
    }
    const evt = "CYourOpinion";
    const onClickIt = () => {
        analyticsEvent(GG_CATEGORY.OTHER, evt, evt);
        window.open(opinionLink, "_blank");
    }
    return (<div className="yourOpinion"
                 title={opinionTitle}
                 onClick={onClickIt}
    ><RxChatBubble/> {t('home.opinion')}</div>);
}
export default withTranslation('common')(CYourOpinion);

